/*
 * Copyright (c) 2022. Dave van Rijn Development
 */
import './style/bulb-icon.scss';

import {AwesomeIcon} from '@dvrd/dvr-controls';
import classNames from 'classnames';
import React, {MouseEventHandler} from 'react';

interface Props {
    onClick?: MouseEventHandler;
    title?: string;
    className?: string;
    size?: number;
}

const sizes = {
    outer: 28,
    inner: 20,
    bulb: 10,
    bulbWidth: 6,
    outerBorder: 4,
    innerBorder: 2,
}

export default function BulbIcon(props: Props) {
    const {title, onClick, className} = props;
    const size = props.size ?? 1;
    const outerSize = sizes.outer * size + 'px';
    const innerSize = sizes.inner * size + 'px';
    const bulbSize = sizes.bulb * size + 'px';
    const bulbWidth = sizes.bulbWidth * size + 'px';
    const outerBorderSize = sizes.outerBorder * size + 'px';
    const innerBorderSize = sizes.innerBorder * size + 'px';

    return (
        <div className={classNames('bulb-icon', className)} title={title} onClick={onClick}
             style={{width: outerSize, height: outerSize, borderWidth: outerBorderSize}}>
            <div className='bulb-container' style={{width: innerSize, height: innerSize, borderWidth: innerBorderSize}}>
                <AwesomeIcon name='lightbulb' className='bulb'
                             style={{fontSize: bulbSize, height: bulbSize, width: bulbWidth}}/>
            </div>
        </div>
    )
}